import * as z from 'zod';

export const GetConversationRequest = z.object({});
export const GetConversationResponse = z.object({
  conversation: z
    .object({
      _id: z
        .string()
        .describe('Conversation ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional(),
      contact: z
        .boolean()
        .describe(
          'Whether the site visitor engaging in this conversation is a contact.'
        )
        .optional(),
      _createdDate: z
        .date()
        .describe('Date and time the conversation was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the conversation was updated.')
        .optional()
        .nullable(),
    })
    .describe('Retrieved conversation.')
    .optional(),
});
